import { useContext } from 'react';
import type { SpLogicCrudlDocumentApi } from '@sp-api/documents-api';
import ApiContext from '../components/ApiProvider/ApiContext';

export default function useDocumentApiClient(): SpLogicCrudlDocumentApi {
  const { documentApi } = useContext(ApiContext);

  return documentApi;
}
